// src/utils/PersianNumberUtils.js

/**
 * تابع کمکی برای تبدیل ارقام انگلیسی موجود در یک رشته یا عدد، به ارقام فارسی.
 * این تابع برای فیلدهایی که قیمت (شامل واحد و جداکننده) را به صورت رشته دارند، مناسب است.
 * * @param {string | number} input - رشته یا عددی که باید ارقامش فارسی شود.
 * @returns {string} - رشته‌ای با ارقام فارسی.
 */
export const convertToPersianNumbers = (input) => {
    if (input === null || input === undefined) return '';

    const str = input.toString();
    const persianMap = {
        '0': '۰', '1': '۱', '2': '۲', '3': '۳', '4': '۴', 
        '5': '۵', '6': '۶', '7': '۷', '8': '۸', '9': '۹'
    };
    
    // جایگزینی تمام ارقام انگلیسی با معادل فارسی
    return str.replace(/[0-9]/g, (match) => persianMap[match]);
};

// مثال:
// const result = convertToPersianNumbers("120,000 تومان"); // خروجی: "۱۲۰,۰۰۰ تومان"